/**
 * Gets the template use case for a contract.
 * @function
 * @param {Object} option - The option object.
 * @returns {string} The template use case.
 */
export const getContractTemplateUseCase = (option) => {
  if (option?.type === 'owner') return 'OWNER_CONTRACT';

  if (option?.type === 'pensioner') {
    return option?.internet_access === false
      ? 'PENSIONER_CONTRACT_WITHOUT_INTERNET'
      : 'PENSIONER_CONTRACT';
  }

  return null;
};

/**
 * Gets the template use case for information.
 * @function
 * @param {Object} option - The option object.
 * @returns {string} The template use case.
 */
export const getInformationTemplateUseCase = (option) => {
  if (option?.type === 'owner') return 'OWNER_INFORMATIONS';
  if (option?.type === 'pensioner') return 'PENSIONER_INFORMATIONS';
  return null;
};
